import { useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { ParentTicketForm } from '@/components/forms/ParentTicketForm'
import { useHelpdeskStore } from '@/store/helpdesk'
import { useParentTicketDraftStore } from '@/store/parentTicketDraft'

export default function ParentTicketCreationPage() {
  const [searchParams] = useSearchParams()
  const requestId = searchParams.get('request_id')

  const items = useHelpdeskStore((s) => s.items)

  const acknowledgedRequest = useMemo(() => {
    if (!requestId) return null
    return (
      items.find((item) => item.status === 'ACKNOWLEDGED' && item.id === requestId) ??
      null
    )
  }, [items, requestId])

  useEffect(() => {
    if (!acknowledgedRequest) return
    useParentTicketDraftStore.getState().hydrateFromRequest(acknowledgedRequest)
  }, [acknowledgedRequest])

  return <ParentTicketForm />
}
